module.exports = __webpack_public_path__ + "img/cancun-bay-pool-4.d2251a9e.jpg";